import Vuex, { Store as VueStore } from 'vuex';
import Vue from 'vue';
Vue.use(Vuex);
class Store extends VueStore {
    constructor(options, pkg, idg) {
        super(options);
        this.package = pkg;
        this.idg = idg;
    }
}
export default Store;
